import React from "react";

export const transaksiMasukDetailTable = (handleDeleteDetail) => {
  return [
    {
      title: "Nomor Transaksi",
      render: (rowData) => {
        return <span>{rowData.nomor_transaksi_masuk}</span>;
      },
    },
    {
      title: "Jumlah Transaksi Masuk",
      render: (rowData) => {
        return <span>{rowData.jumlah_transaksi_masuk}</span>;
      },
    },
    {
      title: "Created At",
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleDeleteDetail(rowData)}
            >
              Delete
            </button>
          </>
        );
      },
    },
  ];
};
